import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import publicService from '../services/publicService';
import ProductList from '../components/product/ProductList';
import CampaignMedia from '../components/home/CampaignMedia';
import Loading from '../components/common/Loading';
import SEO from '../components/common/SEO';
import Reveal from '../components/common/Reveal';
import './Campaign.css';

const Campaign = () => {
  const { slug } = useParams();
  const [campaign, setCampaign] = useState(null);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        setLoading(true);
        setNotFound(false);
        setError(null);

        const data = await publicService.getCampaign(slug);
        if (cancelled) return;

        setCampaign(data.campaign);
        setProducts(data.products || []);
      } catch (err) {
        if (cancelled) return;
        if (err.response?.status === 404) {
          setNotFound(true);
        } else {
          setError(err.message || 'Failed to load this collection');
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (loading) return <Loading />;

  if (notFound) {
    return (
      <div className="campaign-page campaign-page--empty">
        <SEO title="Collection not found" />
        <h1 className="campaign-empty-title">This collection has ended</h1>
        <p className="campaign-empty-text">
          The promotion you are looking for is no longer running.
        </p>
        <a href="/products" className="campaign-empty-link">
          Browse all products
        </a>
      </div>
    );
  }

  if (error) {
    return <div className="error-message">Error: {error}</div>;
  }

  return (
    <div className="campaign-page">
      <SEO
        title={campaign.title}
        description={campaign.subtitle || `Shop the ${campaign.title} collection at Essentick.`}
      />

      <header className="campaign-page-banner">
        <CampaignMedia campaign={campaign} as="h1" showCta={false} eager />
      </header>

      <Reveal as="section" className="campaign-page-products">
        <ProductList products={products} />
      </Reveal>
    </div>
  );
};

export default Campaign;
